import { memo } from 'react';
import { useTheme } from '@mui/material';
import ForgotPasswordIllustrationLight from './forgotPassword.svg?react';
import ForgotPasswordIllustrationDark from './forgotPassword_dark.svg?react';

export const ForgotPasswordIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <ForgotPasswordIllustrationDark aria-hidden="true" {...props} />;
    return <ForgotPasswordIllustrationLight aria-hidden="true" {...props} />;
  },
);
